import { render, staticRenderFns } from "./confirmChangeBook.vue?vue&type=template&id=222c76b4&scoped=true&"
import script from "./confirmChangeBook.vue?vue&type=script&lang=js&"
export * from "./confirmChangeBook.vue?vue&type=script&lang=js&"
import style0 from "./confirmChangeBook.vue?vue&type=style&index=0&id=222c76b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c76b4",
  null
  
)

export default component.exports